import { makeMediaQueryStore } from './make_media_query_store';

export const useCanHover = makeMediaQueryStore('(hover: hover)');
